import React, { useEffect, useState } from 'react';
import { portalApi, formatApiError } from '../../services/api';
import { Ticket } from '@phosphor-icons/react';
import { toast } from 'sonner';

const fmtEUR = (v) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(v || 0));

export default function PortalTickets() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await portalApi.tickets();
        setItems(r.data || []);
      } catch (err) { toast.error(formatApiError(err)); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="p-6 space-y-6" data-testid="portal-tickets-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-[#111418]">Strafzettel</h1>
        <p className="text-[#525866] mt-1">Ihre Verkehrsdelikte in Verbindung mit Mietfahrzeugen</p>
      </div>

      {loading ? (
        <div className="card-swiss h-24 skeleton" />
      ) : items.length === 0 ? (
        <div className="card-swiss p-12 text-center">
          <Ticket weight="thin" size={64} className="mx-auto text-[#8A94A6] mb-4" />
          <p className="text-[#525866]">Keine Strafzettel vorhanden.</p>
        </div>
      ) : (
        <div className="card-swiss overflow-hidden">
          <table className="table-swiss">
            <thead><tr><th>Nummer</th><th>Datum</th><th>Verstoß</th><th className="text-right">Betrag</th><th>Status</th></tr></thead>
            <tbody>
              {items.map((t) => (
                <tr key={t.id} data-testid={`portal-ticket-row-${t.id}`}>
                  <td className="font-semibold">{t.ticket_number}</td>
                  <td className="text-sm text-[#525866]">{t.violation_date || (t.created_at || '').slice(0, 10)}</td>
                  <td className="text-sm">{t.violation_type || t.description || '—'}</td>
                  <td className="text-right font-semibold">{fmtEUR(t.fine_amount)}</td>
                  <td><span className="text-xs px-2 py-1 rounded bg-[#F5F7FA] text-[#525866] font-semibold">{t.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
